module.exports = __webpack_public_path__ + "img/discount-tag.419cfa54.svg";